import { ErrorBannerSchema } from './ErrorBanner.styles';

export const errorBannerStyles: ErrorBannerSchema = {
  flexWrapper: {
    bg: 'beta.800',
    h: '8',
    w: '72',
    color: 'beta.100',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'absolute',
    top: -8,
    left: '30%',
    zIndex: 9999,
  },
  errorText: {},
};
